// Quipper Campus simple validation library
// ===============================================

// formats
/* eslint-disable no-useless-escape */
const emailFormat = /^(?!.*?[.]{2})[a-z0-9]+[a-z0-9._%\-+]*[a-z0-9]@[a-z0-9]+[a-z0-9.\-]*[a-z0-9]*\.[a-z]{2,4}$/
const usernameFormat = /^[a-zA-Z0-9._-]+$/
const numberFormat = /^[0-9]*$/
const betweenFormat = (x, min, max) => (x >= min && x <= max)
/* eslint-enable no-useless-escape */

// validation rules
const validationRules = {
  required: value => (value && !!value.toString().trim().length),
  email: value => emailFormat.test(value),
  username: value => usernameFormat.test(value),
  email_username: value => emailFormat.test(value) || usernameFormat.test(value),
  phone_number: value => numberFormat.test(value) && betweenFormat(value.length, 8, 13),
  contains_text_and_number: value => /[a-zA-Z]/.test(value) && /[0-9]/.test(value),
  min_length: value => value.length >= 6,
  min_length_utbk: value => value.length >= 10,
}

export default class Validator {
  static rules() {
    return Object.keys(validationRules)
  }

  static validate(value, rules) {
    const errors = []

    rules.forEach((rule) => {
      const isValid = validationRules[rule](value)
      if (!isValid) errors.push(rule)
    })

    return errors
  }
}
